// TODO: mover componente a ats-app: Configuracion de etapa
import React, { useEffect, useState } from "react";
import { commonsHelper } from "../../../helpers";
import { OrganizationDefaultColumnService } from "@frontend/src/core/services/organization_default_column_service";
import { SelectionProcessesService } from "@frontend/src/core/services/selection_processes_service";
import { TemplatesService } from "@frontend/src/core/services/templates_service";
import { metadata } from "../../selection_processes/settings/initialStates";
import { openNotificationWithIcon } from "@frontend/src/utilities/notificationWithIcon";
import FormEditStep from "../form_edit_step/FormEditStep";
import { debounce } from "lodash-es";
import { Modal } from "antd";
import { set } from "js-cookie";

const noData = {
  active: true,
  id: null,
  title: "Sin plantilla"
}

const ModalAddStep = ({ isModalVisible, onCancelModal, organizationId }) => {
  const [userList, setUserList] = useState({
    data: [],
    pagination: metadata,
  });
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false); 
  const [searchTerm, setSearchTerm] = React.useState("");
  const [templates, setTemplates] = useState([]);
  const [emailTemplates, setEmailTemplates] = useState([])
  const organizationColumnService = new OrganizationDefaultColumnService();
  const selectionProcessesService = new SelectionProcessesService();
  const templatesService = new TemplatesService();

  useEffect(() => {
    handleGetAllUsers(userList.pagination.currentPage);
    templatesService.getAll(organizationId, handleTemplateSettings, console.error);
  }, []);

  const handleGetAllUsers = (page, term) => {
    setLoading(true);
    selectionProcessesService
      .listUsers([], page, 10, term, "")
      .then(({ data, headers }) => {
        const mainData = {
          data,
          pagination: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        if (page > 1) {
          setUserList((value) => ({
            data: value.data.concat(mainData.data),
            pagination: mainData.pagination,
          }));
        } else {
          setUserList(mainData);
        }

        if (!term) {
          setUserList((value) => ({
            data: value.data.concat(
              mainData.data.filter((it) => selectedUsers.includes(it.id))
            ),
            pagination: mainData.pagination,
          }));
        }

        setLoading(false);
      });
  };

  const handleInfiniteScroll = ({
    target: { scrollHeight, scrollTop, clientHeight },
  }) => {
    const { nextPage } = userList.pagination;
    if (scrollHeight < scrollTop + clientHeight + 50 && nextPage && !loading) {
      searchTerm
        ? handleGetAllUsers(nextPage, searchTerm)
        : handleGetAllUsers(nextPage);
    }
  };

  const debouncedSearch = React.useCallback(
    debounce(handleGetAllUsers, 300),
    []
  );

  const onSearch = (term) => {
    setSearchTerm(term);
    term ? debouncedSearch(1, term) : setUserList(userList);
  };

  const handleSelect = (value) => {
    const selectedUserData = userList.data.find((item) => item.id === value);
    setSelectedUsers([...selectedUsers, selectedUserData]);
  };

  const handleDeselect = (value) => {
    const selectedUsersData = selectedUsers.filter((item) => item.id !== value);
    setSelectedUsers(selectedUsersData);
  };

  const handleTemplateSettings = (data) => {
    const user_profile = data?.user_profile ? [noData, ...data.user_profile] : [noData]
    const email = data?.emails ? [noData, ...data.emails]: [noData]
    setTemplates(user_profile)
    setEmailTemplates(email)
  }

  const onAddSubmit = (e, form) => {
    e.preventDefault();
    form.validateFields((_err_q, values) => {
      if (_err_q?.name) return;
      let columnData = {}
      setDisableSubmit(true)
      columnData['report_templates'] = [values.report_templates]
      columnData['external_users'] = values.external_users.length > 0 ? values.external_users.split(";") : []
      columnData['name'] = values.name
      columnData['user_columns'] = values.user_columns
      columnData['user_columns_active'] = values.user_columns_active
      columnData['responsible_active'] = values.responsible_active
      columnData['author_active'] = values.author_active
      columnData['managers_active'] = values.managers_active
      columnData['move_templates'] = values.move_templates
      columnData['disqualify_templates'] = values.disqualify_templates
      columnData['enable_limit_applicants'] = values.enable_limit_applicants

      columnData['sla_setting_attributes'] = {
        active: values.sla_count ? true : false,
        max_days: values.sla_count? values.sla_count : 0 
      }

      if (values.applicant_requirements) {
        columnData['applicant_requirements'] = values.applicant_requirements.map(
          (id) => ({
            value: values.applicant_requirement_value[id],
            condition: values.applicant_requirement_condition[id],
            required_type: 'relation_table',
            required_field: 'applicant_files'
          })
        );
      }
      organizationColumnService.create(
        columnData,
        (data) => {
          setDisableSubmit(false);
          window.location.reload(false);
          openNotificationWithIcon("success", "Etapa creada correctamente", "");
          onCancelModal(false);
        },
        (_err) => {}
      );
    });
  };

  return (
    <Modal
      className="ModalEditStep"
      title={"Nueva etapa"}
      visible={isModalVisible}
      footer={null}
      onCancel={onCancelModal}
      width="50%"
    >
      <FormEditStep
        templates={templates}
        onSearch={onSearch}
        handleSelect={handleSelect}
        handleInfiniteScroll={handleInfiniteScroll}
        loading={loading}
        userList={userList}
        disableSubmit={disableSubmit}
        handleSubmitEdit={onAddSubmit}
        handleDeselect={handleDeselect}
        emailTemplates={emailTemplates}
      />
    </Modal>
  );
};

export default ModalAddStep;
